var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var ErrorStore = /** @class */ (function () {
    function ErrorStore() {
        this.errors = [];
        this.listeners = new Set();
        this.maxErrors = 10;
    }
    ErrorStore.prototype.addError = function (error, severity) {
        if (severity === void 0) { severity = 'high'; }
        // Avoid duplicates (same message within 5 seconds)
        var isDuplicate = this.errors.some(function (e) {
            return e.message === error.message &&
                Date.now() - new Date(e.timestamp).getTime() < 5000;
        });
        if (isDuplicate) {
            return;
        }
        var errorItem = {
            id: Date.now() + "-" + Math.random().toString(36).substr(2, 9),
            message: error.message || error.toString() || 'Unknown error',
            timestamp: new Date(),
            severity: severity,
            details: error,
            reported: false,
            stack: error.stack
        };
        this.errors.unshift(errorItem);
        if (this.errors.length > this.maxErrors) {
            this.errors = this.errors.slice(0, this.maxErrors);
        }
        this.notifyListeners();
    };
    ErrorStore.prototype.getErrorCount = function () {
        return this.errors.filter(function (e) { return !e.reported; }).length;
    };
    ErrorStore.prototype.getErrors = function () {
        return __spreadArray([], this.errors, true);
    };
    ErrorStore.prototype.markAsReported = function (id) {
        var error = this.errors.find(function (e) { return e.id === id; });
        if (error) {
            error.reported = true;
            this.notifyListeners();
        }
    };
    ErrorStore.prototype.removeError = function (id) {
        this.errors = this.errors.filter(function (e) { return e.id !== id; });
        this.notifyListeners();
    };
    ErrorStore.prototype.clearAll = function () {
        this.errors = [];
        this.notifyListeners();
    };
    ErrorStore.prototype.subscribe = function (listener) {
        var _this = this;
        this.listeners.add(listener);
        return function () { return _this.listeners.delete(listener); };
    };
    ErrorStore.prototype.notifyListeners = function () {
        this.listeners.forEach(function (listener) { return listener(); });
    };
    return ErrorStore;
}());
// Singleton instance
export var errorStore = new ErrorStore();
